import Axios from "../../Config/API";
import Service from "../../Service";

export async function AtualizarBoletoQuitadoCasoCobrancaNegociacaoParcelasService(
    idCasoCobrancaNegociacaoParcelas: number
) {
    return Service(
        Axios.put(
            `/cobranca/casocobrancanegociacaoparcelas/atualizarboletoquitadocasocobrancanegociacaoparcelas?idCasoCobrancaNegociacaoParcelas=${idCasoCobrancaNegociacaoParcelas}`
        )
    );
}

export async function AtualizarBoletoNaoQuitadoCasoCobrancaNegociacaoParcelasParcelasService(
    idCasoCobrancaNegociacaoParcelas: number
) {
    return Service(
        Axios.put(
            `/cobranca/casocobrancanegociacaoparcelas/atualizarboletonaoquitadocasocobrancanegociacaoparcelas?idCasoCobrancaNegociacaoParcelas=${idCasoCobrancaNegociacaoParcelas}`
        )
    );
}

export async function AtualizarBoletoEnviadoCasoCobrancaNegociacaoParcelasService(
    idCasoCobrancaNegociacaoParcelas: number
) {
    return Service(
        Axios.put(
            `/cobranca/casocobrancanegociacaoparcelas/atualizarboletoenviadocasocobrancanegociacaoparcelas?idCasoCobrancaNegociacaoParcelas=${idCasoCobrancaNegociacaoParcelas}`
        )
    );
}

export async function AtualizarBoletoNaoEnviadoCasoCobrancaNegociacaoParcelasService(
    idCasoCobrancaNegociacaoParcelas: number
) {
    return Service(
        Axios.put(
            `/cobranca/casocobrancanegociacaoparcelas/atualizarboletonaoenviadocasocobrancanegociacaoparcelas?idCasoCobrancaNegociacaoParcelas=${idCasoCobrancaNegociacaoParcelas}`
        )
    );
}

export async function AtualizarBoletoGeradoCasoCobrancaNegociacaoParcelasService(
    idCasoCobrancaNegociacaoParcelas: number
) {
    return Service(
        Axios.put(
            `/cobranca/casocobrancanegociacaoparcelas/atualizarboletogeradocasocobrancanegociacaoparcelas?idCasoCobrancaNegociacaoParcelas=${idCasoCobrancaNegociacaoParcelas}`
        )
    );
}
